import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import "./assets/index.css"
import "element-plus/dist/index.css"
import { getuserinfoAPI } from "./api/api"
const token = localStorage.getItem("token")
const login = () => {
    getuserinfoAPI().then((res) => {
        if (res.code === "8200") {
            localStorage.setItem("userinfo", JSON.stringify(res.data || {}))
            localStorage.setItem("role", res.data.role)
        }
    })
}
if (token) {
    login()
}

// import "vue-easytable/libs/theme-default/index.css";
// 引入组件库
// import VueEasytable from "vue-easytable";
createApp(App).use(router).mount("#app")
